// shop-drop.component.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductBox2 from "../../components/product-box-2/product-box-2.component";
import "./shop-drop.styles.css";

const ShopDrop = () => {
  const [productsData, setProductsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllDrops = async () => {
      try {
        let allProducts = [];
        let nextPageUrl =
          "https://mediumaquamarine-rat-574365.hostingersite.com/api/drops";

        while (nextPageUrl) {
          const formData = new FormData();
          formData.append("campaign_id", "2");

          const response = await axios.post(nextPageUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.is_status) {
            const { products, link } = response.data.data;
            allProducts = [...allProducts, ...products];
            nextPageUrl = link.next;
          } else {
            nextPageUrl = null;
          }
        }

        setProductsData(allProducts);
      } catch (error) {
        console.error("Error fetching drops:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllDrops();
  }, []);

  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="shop">
      <div className="container">
        <div className="path-text-wrapper">
          <Link to="/">
            <p className="path-text">خانه</p>
          </Link>
          <span className="path-line"></span>
          <p className="path-text">دراپ</p>
        </div>
        <div className="shop-directory">
          {productsData.map((product) => (
            <ProductBox2
              key={product.id}
              cat={{
                id: product.id,
                title: product.title,
                catText: product.productCategory,
                price: product.price,
                discountprice: product.discount_price,
                img: product.image,
                colors: product.colors || [],
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopDrop;
